module.exports = __webpack_public_path__ + "static/media/receive-wpkt.479e8b68.svg";